if (!customElements.get('skt-bundle-offer')) {
  customElements.define('skt-bundle-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.button.setAttribute('aria-haspopup', 'dialog');
      this.error = this.querySelector('.skt-bundle-offer__error');
      this.radios = [...this.querySelectorAll('.skt-bundle-offer__radio')];
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.addEventListener('change', event => {
        if (!event.target.matches('.skt-bundle-offer__radio')) return;
        this.form.elements.quantity.value = event.target.dataset.quantity;
        this.error.hidden = true;
        this.updateAvailability();
      }, options);
      this.form.addEventListener('submit', event => this.submit(event), options);
      this.updateAvailability();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.initialized = false;
    }

    get selectedOption() {
      return this.radios.find(radio => radio.checked) || this.radios[0];
    }

    getItems() {
      const option = this.selectedOption;
      const id = this.form.elements.id.value;
      const quantity = Number(option?.dataset.quantity);
      if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1) {
        throw new Error(this.dataset.unavailableMessage);
      }
      const items = [{ id, quantity }];
      if (option.dataset.giftEnabled === 'true') {
        const giftId = option.dataset.giftVariantId;
        // Shopify rejects a variant nested under itself as a circular reference.
        if (!/^\d+$/.test(giftId || '') || giftId === id) throw new Error(this.dataset.unavailableMessage);
        items.push({ id: giftId, quantity: 1, parent_id: id });
      }
      return items;
    }

    updateAvailability() {
      const inStock = this.dataset.productAvailable === 'true';
      const giftReady = this.selectedOption?.dataset.giftEnabled !== 'true' || (
        this.selectedOption.dataset.giftAvailable === 'true' &&
        /^\d+$/.test(this.selectedOption.dataset.giftVariantId || '') &&
        this.selectedOption.dataset.giftVariantId !== this.form.elements.id.value
      );
      this.ready = Boolean(this.radios.length && inStock && giftReady);
      this.dataset.offerReady = String(this.ready);
      this.button.disabled = Boolean(this.busy || !inStock || !giftReady || !this.radios.length);
      this.button.setAttribute('aria-disabled', String(this.button.disabled));
      const label = this.querySelector('[data-button-label]');
      label.textContent = !inStock || !giftReady ? this.dataset.soldLabel : this.dataset.addLabel;
      const stock = this.querySelector('.skt-bundle-offer__stock');
      if (stock) {
        stock.classList.toggle('skt-bundle-offer__stock--sold-out', !inStock || !giftReady);
        stock.querySelector('[data-stock-caption]').textContent = inStock && giftReady ? this.dataset.stockText : this.dataset.soldLabel;
        const delivery = stock.querySelector('.skt-bundle-offer__delivery');
        if (delivery) delivery.hidden = !inStock || !giftReady;
      }
      const note = this.querySelector('.skt-bundle-offer__editor-note');
      if (note) {
        note.hidden = this.ready;
        note.textContent = this.dataset.editorMessage;
      }
    }

    async submit(event) {
      event.preventDefault();
      if (this.busy || this.button.disabled) return;
      this.busy = true;
      this.error.hidden = true;
      this.updateAvailability();
      this.querySelector('.skt-bundle-offer__spinner').hidden = false;
      try {
        const cart = document.querySelector('cart-drawer');
        const payload = { items: this.getItems() };
        if (cart) {
          payload.sections = cart.getSectionsToRender().map(section => section.id);
          payload.sections_url = window.location.pathname;
          cart.setActiveElement(this.button);
        }
        const body = JSON.stringify(payload);
        const addUrl = this.dataset.addUrl.replace(/\.js$/, '') + '.js';
        const response = await fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.unavailableMessage);
        if (cart && payload.sections.every(id => typeof result.sections?.[id] === 'string')) {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        } else {
          // Adding succeeded; do not invite a duplicate add if section rendering failed.
          window.location.assign(this.dataset.cartUrl);
        }
      } catch (error) {
        this.showError(error instanceof TypeError ? this.dataset.networkMessage : error.message);
      } finally {
        this.busy = false;
        this.querySelector('.skt-bundle-offer__spinner').hidden = true;
        this.updateAvailability();
      }
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = false;
    }
  });
}
